import StateManager from './StateManager';
import $ from 'jquery';

/* -------------------------
    CONTENT READY LISTENER
------------------------- */

$(window).on(StateManager.CONTENT_READY, contentReadyHandler);
function contentReadyHandler(event, node) {
    $(node).find('.js-scuba__nav').scubaNav();
}


/* -------------------------
    JQ PLUGIN
------------------------- */

$.fn.scubaNav = function() {
    this.each(function(i, nav) {
        new Navigation(nav);
    });
}





/* --------------------------------------------------

    CONSTRUCTOR

-------------------------------------------------- */

function Navigation(nav) {
    this.$nav = $(nav).addClass('js-scuba__nav');

    // évite une double initialisation
    if (this.$nav.data('__scuba_navInitialized') === true) return;
    this.$nav.data('__scuba_navInitialized', true);

    // récupère les liens de la navigation
    // this.$links = this.$nav.find('a');

    // récupère la page parente (ou header)
    this.$page = this.$nav.closest('.js-scuba__page, .js-scuba__head');
    this.pageUrl = !this.$page.is('.js-scuba__head') ? this.$page.data('url') : null;

    // écouteurs
    this.$nav.on('itemsChanged', $.proxy(this.itemsChangedHandler, this));
    this.$page.on(StateManager.NEXT_PAGES_CHANGED, $.proxy(this._nextPagesChangedHandler, this));
}





/* --------------------------------------------------

    METHODS

-------------------------------------------------- */

Navigation.prototype._nextPagesChangedHandler = function(event, pages) {
    /*var $activeLinks;*/

    this.nextPages = pages;

    this.updateSelection();
}


Navigation.prototype.updateSelection = function() {
    var $activeLinks, $links = this.$nav.find('a');
    $.each(this.nextPages, $.proxy(function(i, page) {
        $activeLinks = $links.filter('[href="'+ page.url +'"], [href$="'+ window.wpscuba.home_url.replace(/(^\w+:|^)/, '') + page.url +'"]');
        if ($activeLinks.length > 0) {
            $activeLinks.addClass('is-active');
            return false; // équivalent de break
        } else {
            $activeLinks = null;
        }
    }, this));

    $links.not($activeLinks).removeClass('is-active');
    $activeLinks && this.bubbleSelection($activeLinks);
}

Navigation.prototype.bubbleSelection = function($activeLink) {
    var $ul = $activeLink.closest('ul');

    // var $ulClone = $ul.data('dgt-nav-clone');
    // if ($ulClone) {
    //     var href = $activeLink.attr('href');
    //     $ulClone.find('a').removeClass('current').filter('a[href="'+ href +'"]').addClass('current');
    // }

    // sélectionne le lien situé à côté du ul parent
    var $parentLink = $ul.prev('a');
    if ($parentLink.length > 0) {
        $parentLink.addClass('is-active');
        this.bubbleSelection($parentLink);
    }
}


// WEBPACK FOOTER //
// ./scripts/scuba/Navigation.js